// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/Signup.tsx
// Version: v2.0.0
// v2.0.0 - Die Seite ist abgeloest (L-6, Inhaber 10.10.2026: "Mach diese Stelle genauso in diesem Style wie
//          die Anmeldung"): Konto erstellen laeuft Schritt fuer Schritt in components/LoginFlow. /signup
//          (von /pricing mit ?plan=, alte Links mit ?email=) leitet dorthin weiter - nichts geht ins Leere.
// v1.1.0 - ?email= aus dem Login-Fenster vorbelegen.
// v1.0.0 - Signup-Formular: Firmenname, Subdomain (Live-Check), Name, E-Mail, Passwort, AGB

import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function Signup() {
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const next = new URLSearchParams({ register: "1" });
    const plan = searchParams.get("plan");
    const email = searchParams.get("email");
    if (plan) next.set("plan", plan);
    if (email) next.set("email", email);
    window.location.replace(`/login?${next.toString()}`);
  }, [searchParams]);
  return null;
}
